<template>
  <div class="table storicoacquisti" v-if="!(loading && isMobile)"><!--v-if="!isMobile"-->
    <!-- <caption>Statement Summary</caption> -->
    <div class="thead">
      <div class="tr">
        <div class="th" scope="col">{{ 'OrderStatus' | lang }}</div>
        <div class="th" scope="col">{{ 'DueDate' | lang }}</div>
        <div class="th" scope="col">{{ 'Amount' | lang }}</div>
        <div class="th" scope="col">{{ 'NumberOfItems' | lang }}</div>
      </div>
    </div>
    <div class="tbody" style="overflow-y:auto">
      <div v-for="(p, idx) in lstFiltered" :key="idx" class="tr" @click="openDetails(p)">
        <div class="td" :data-label="dictValue('OrderStatus')">{{p.OrderStatusLabel}}</div>
        <div class="td" :data-label="dictValue('DueDate')">{{p.OrderChangeDate | date}}</div>
        <div class="td" :data-label="dictValue('Amount')">{{(p.TotalCashAmount / 100) | currency}}</div>
        <div class="td" :data-label="dictValue('NumberOfItems')">{{p.OrderItemWebApi.length}}</div>
      </div>
      <div slot="loading" v-if="loading" class="tr loading">{{ 'IsLoading' | lang }}</div>
      <div slot="loading" v-else-if="totalFiltered === lstFiltered.length" class="tr loading">{{ lstFiltered.length > 0 ? 'NoOtherOrders' : 'NoOrder' | lang }}</div>
    </div>
    <div class="tfoot">
      <div class="pagination">
        <span v-if="!loading && (totalFiltered > 0)">{{ 'FilteredItems' | lang(null, { a: (totalFiltered || 0), b: lstPreFiltered.length || '-' }) }}</span>
      </div>
      <button @click="openFilters" :disabled="!total || total === Infinity">{{ 'Filters' | lang }}<i class="fa fa-fw fa-filter"></i></button>
    </div>
  </div>
  <div v-else-if="loading" class="flexcentered bigger">
    {{'IsLoading' | lang}}
  </div>
  <div v-else class="table">
    <div class="thead">
      <ul class="nav">
        <li v-for="(p, idx) in lstFiltered" :key="idx" @click="openDetails(p)">
          <div style="width:100%">
            <div class="main space-between"><span>{{p.OrderStatusLabel}}</span><span>{{(p.Amount / 100) | currency}}</span></div>
            <div class="sub">{{'NumberOfItems' | lang}}: {{p.OrderItemWebApi.length}}</div>
            <div class="sub">{{'DueDate' | lang }}: {{p.OrderChangeDate | date}}</div>
            <!--<div class="sub space-between"><span>{{t.addedDateTime | datetime}}</span><span>{{(t.amount/100) | currency}}&nbsp;</span></div>-->
          </div>
          <!-- <div>
            <i class="fa fa-fw fa-check double-check" v-if="t.validated" :class="{ 'first-check': t.validated, 'second-check': t.vadValidated}"></i>
            <i class="fa fa-fw fa-chevron-right" v-else></i>
          </div> -->
        </li>
      </ul>
      <div class="tfoot">
        <button @click="openFilters" :disabled="!total || total === Infinity">{{ 'Filters' | lang }}<i class="fa fa-fw fa-filter"></i></button>
      </div>
    </div>
  </div>
</template>

<script>
// import VirtualInfiniteScroller from '@/components/VirtualInfiniteScroller'
import UserServices from '@/mixins/services/userServices'
import DettaglioAcquisto from '@/dialogs/DettaglioAcquisto'
import FiltriStoricoAcquisti from '@/dialogs/FiltriStoricoAcquisti'
import moment from 'moment'
import { create } from 'vue-modal-dialogs'
const DettaglioAcquistoDialogCreator = create(DettaglioAcquisto)
const FiltriStoricoAcquistiDialogCreator = create(FiltriStoricoAcquisti)

export default {
  name: 'StoricoAcquisti',
  mixins: [ UserServices ],
  // components: { VirtualInfiniteScroller },
  data () {
    return {
      test: 1,
      page: 1,
      pagesize: 10,
      total: Infinity,
      lst: [],
      currentDataPromise: null,
      filters: {
        Status: null,
        Amount: [],
        Date: []
      },

      loading: false,
			delta: {},
			scrollInfo: {}
    }
  },
  computed: {
    /* total () {
      return this.lstFiltered.length
    }, */
    totalFiltered () {
      return this.lstFiltered.length
    },
    /* scrollPercHuman () {
      if (!this.total) {
        return '0'
      }
      return Math.min(100, ((this.scrollInfo.visibleFirst + this.scrollInfo.visibleNumber) / this.total) * 100).toFixed(0) + '%'
    }, */
    scrollPercHumanFiltered () {
      if (!this.totalFiltered) {
        return '0'
      }
      return Math.min(100, ((this.scrollInfo.visibleFirst + this.scrollInfo.visibleNumber) / this.totalFiltered) * 100).toFixed(0) + '%'
    },
    lstPreFiltered () {
      return this.lst.filter(order => order.Status !== 'inBasket')
    },
    lstFiltered () {
      let lst = this.lstPreFiltered
      if (this.filters.Status) {
        lst = lst.filter(order => order.Status === this.filters.Status)
      }
      if (this.filters.Amount && this.filters.Amount.length === 2) {
        lst = lst.filter(order => order.Amount >= this.filters.Amount[0] && order.Amount <= this.filters.Amount[1])
      }
      if (this.filters.Date && this.filters.Date.length === 2) {
        lst = lst.filter(order => order.OrderChangeDate.slice(0, 10) >= this.filters.Date[0] && order.OrderChangeDate.slice(0, 10) <= this.filters.Date[1])
      }
      return lst
    },
    statusOptions () {
      let dict = {}
      this.lst.forEach(order => {
        dict[order.Status] = { key: order.Status, value: order.OrderStatusLabel }
      })
      delete dict['inBasket']
      let statuses = Object.values(dict)
      statuses.sort((a,b) => a.value > b.value)
      return statuses
    },
    amountBounds () {
      let amounts = this.lstPreFiltered.map(order => order.Amount)
      return {
        min: Math.min(...amounts),
        max: Math.max(...amounts)
      }
    },
    dateBounds () {
      let dates = this.lstPreFiltered.map(order => new Date(order.OrderChangeDate))
      if (dates.length) {
        let min = Math.min(...dates)
        let max = Math.max(...dates)
        return {
          min: new Date(min).toISOString().slice(0, 10),
          max: new Date(max).toISOString().slice(0, 10)
        }
      }
      return {
        min: null,
        max: null
      }
    }
  },
  methods: {
    openFilters () {
      FiltriStoricoAcquistiDialogCreator({ filters: this.filters, statusOptions: this.statusOptions, amountBounds: this.amountBounds, dateBounds: this.dateBounds,
      allDates: this.lstPreFiltered.map(order => new Date(order.OrderChangeDate)), allPrices: this.lstPreFiltered.map(order => order.Amount) }).then(newFilters => {
        this.filters = newFilters || {}
      })
    },
    openDetails (order) {
      // console.log('Opening order detail', order)
      DettaglioAcquistoDialogCreator({ order })
    },
    updatedZone() {},
		onBottom() {
			// console.log("Bottom!!")
		},
		closeToBottom() {
			// console.log("Close to bottom!!")
			if (this.loading) {
				return;
			}
			this.updateData()
		},
    updateData () {
      if (this.user && this.lst.length < this.total) {
        this.loading = true
        let pr = this._getUserPayments(0/*this.lst.length*/, 100000000000)
        this.currentDataPromise = pr
        pr.then(data => {
          if (this.currentDataPromise === pr) {
            data.forEach(order => {
              if (order.OrderChangeDate === '0001-01-01T00:00:00') {
                order.OrderChangeDate = order.OrderCreationDate
              }
            })
            data.forEach(order => { order.dateDays = moment(order.OrderChangeDate).diff(moment([2010, 0, 1]), 'days')})
            data.sort((a, b) => b.OrderChangeDate === a.OrderChangeDate ? 0 : (b.OrderChangeDate > a.OrderChangeDate ? 1 : -1))
            this.lst = data
            this.total = data.length
            this.loading = false
          }
        }).catch(e => {
          this.loading = false
          console.error(e)
          this.internalBus.$emit('notify:error', {
            text: this.dictValue('errorOccured') + (e.status === 418 ? '[VAD]' : ''),
            key: this.notifierKey
          })
        })
      }
    }
  },
  mounted () {
    this.updateData()
  },
  watch: {
    user () {
      if (this.isFullLogged && this.user) {
        this.updateData()
      }
    },
    amountBounds (newV) {
      this.filters.Amount = [newV.min, newV.max]
    },
    dateBounds (newV) {
      this.filters.Date = [newV.min, newV.max]
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/_vars.scss';

#app.desktop .storicoacquisti {
  max-height: 30rem;
  margin-top: .5rem;
}

#app.mobile .storicoacquisti {
  height: 100%;
}


#app.desktop .storicoacquisti .tr
{
  cursor: pointer,
}

.table .tfoot {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
/* .table .tfoot .pagination {
  /* position: sticky;
  bottom: -0.5rem;
  width: calc(100% - 2rem);
  background-color: var(--white);
  border: 1px solid lightgray;
  border-radius: .3rem;
  padding: .5rem;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
} */

</style>
